module.exports = __webpack_public_path__ + "img/Tick.bb0e5fe3.svg";